class SkioSubscription extends HTMLElement {
  connectedCallback() {
    try {
      this.data = JSON.parse(this.querySelector('[data-skio-subscription-data]')?.textContent || '{}');
    } catch (error) {
      console.error('[Skio subscription] Unable to read selling-plan data.', error);
      this.data = {};
    }
    this.form = document.getElementById(this.dataset.formId);
    this.select = this.querySelector('[data-selling-plan-selector]');
    this.subscriptionInput = this.querySelector('[data-offer-type="subscription"]');
    this.oneTimeInput = this.querySelector('[data-offer-type="one-time"]');
    this.subscriptionOffer = this.querySelector('[data-subscription-offer]');
    this.oneTimeOffer = this.querySelector('[data-one-time-offer]');
    this.currentVariantId = this.form?.querySelector('[name="id"]')?.value;

    this.select?.addEventListener('change', () => this.render(this.currentVariantId));
    this.subscriptionInput?.addEventListener('change', () => this.updateSelection());
    this.oneTimeInput?.addEventListener('change', () => this.updateSelection());
    this.subscriptionOffer?.addEventListener('click', () => this.selectOffer('subscription'));
    this.oneTimeOffer?.addEventListener('click', () => this.selectOffer('one-time'));

    // Horizon resolves variants asynchronously. Watching the real form input
    // keeps this module in lockstep without replacing Horizon's form logic.
    this.variantWatcher = window.setInterval(() => {
      if (!this.form) this.form = document.getElementById(this.dataset.formId);
      const variantId = this.form?.querySelector('[name="id"]')?.value;
      if (variantId && variantId !== this.currentVariantId) this.render(variantId);
    }, 100);
    if (this.currentVariantId) this.render(this.currentVariantId);
  }

  disconnectedCallback() { window.clearInterval(this.variantWatcher); }

  render(variantId) {
    this.currentVariantId = String(variantId || '');
    const variant = this.data[this.currentVariantId];
    const plans = variant?.plans || [];
    if (!variant || !plans.length) {
      this.classList.add('hidden');
      this.select.disabled = true;
      this.oneTimeInput.checked = true;
      return;
    }

    const wasHidden = this.classList.contains('hidden');
    this.classList.remove('hidden');
    if (!this.hasInitializedSelection || wasHidden) {
      this.subscriptionInput.checked = true;
      this.oneTimeInput.checked = false;
      this.hasInitializedSelection = true;
    }
    const selectedPlanId = this.select.value;
    this.select.replaceChildren(...plans.map((plan) => {
      const option = new Option(plan.name, plan.id, false, plan.id === selectedPlanId);
      return option;
    }));
    if (!this.select.value) this.select.selectedIndex = 0;
    this.updateSelection();
  }

  updateSelection() {
    const variant = this.data[this.currentVariantId];
    if (!variant) return;
    const isSubscription = this.subscriptionInput.checked;
    this.subscriptionOffer?.classList.toggle('is-selected', isSubscription);
    this.oneTimeOffer?.classList.toggle('is-selected', !isSubscription);
    this.select.disabled = !isSubscription;
    const plan = variant.plans.find((item) => item.id === this.select.value) || variant.plans[0];
    if (!plan) return;
    const discount = this.querySelector('[data-discount]');
    const percent = this.percentOff(plan.price, plan.compareAtPrice);
    const isProductCard = Boolean(this.closest('product-card'));
    if (discount) discount.textContent = !isProductCard && percent ? `${percent}% off` : '';
    if (isProductCard) this.updateProductCardPrice(isSubscription, variant, plan);
    this.form?.querySelectorAll('[data-legacy-add-to-cart-price]').forEach((element) => {
      element.textContent = isSubscription ? plan.price : variant.price;
    });
  }

  updateProductCardPrice(isSubscription, variant, plan) {
    const card = this.closest('product-card');
    if (!card) return;

    card.querySelectorAll(`product-price[data-product-id="${this.dataset.productId}"] [ref="priceContainer"]`).forEach((container) => {
      const price = document.createElement('span');
      price.className = 'price-item__group price';
      price.textContent = isSubscription ? plan.price : variant.price;

      const regularPrice = isSubscription ? variant.price : variant.compareAtPrice;
      if (regularPrice && regularPrice !== price.textContent) {
        const compareAt = document.createElement('s');
        compareAt.className =
          'price-item__group price-item--regular compare-at-price skio-subscription-price__compare';
        compareAt.textContent = regularPrice;
        container.replaceChildren(compareAt, price);
      } else {
        container.replaceChildren(price);
      }
    });
  }

  selectOffer(type) {
    const isSubscription = type === 'subscription';
    this.subscriptionInput.checked = isSubscription;
    this.oneTimeInput.checked = !isSubscription;
    this.updateSelection();
  }

  percentOff(price, compareAtPrice) {
    const amount = (value) => Number(String(value || '').replace(/[^0-9.]/g, ''));
    const regular = amount(compareAtPrice);
    const sale = amount(price);
    return regular > sale ? Math.floor(((regular - sale) / regular) * 100) : 0;
  }
}

if (!customElements.get('skio-subscription')) customElements.define('skio-subscription', SkioSubscription);
